export const getToken = ( state ) => {
    if (!state.token) {
        return localStorage.getItem("EXC-token");
    }
    return state.token;
};

export const getRefreshToken = ( state ) => {
    if (!state.refresh_token) {
        return localStorage.getItem('EXC-refreshToken')
    }
    return state.refresh_token
}

export const getClientName = ( state ) => {
    if (!state.clientName) {
        return localStorage.getItem('EXC-clientName')
    }
    return state.clientName
}

export const getUrlBack = ( state ) => {
    if (!state.urlBack) {
        return localStorage.getItem('EXC-urlBack')
    }
    return state.urlBack
}

export const getHeaders = ( state ) => {
    return state.config;
};
